import OWContainer from 'styles/styled-components/ow-container';
import useController from '../controllers/add-product-category-controller';
import { ProductCategoryForm } from '../components/product-categories-form';

export const AddProductCategoryRoute = () => {
    const { formData, onSubmit, onCancel, onChange, isAddProductCategoryLoading, errors } = useController();

    return (
        <OWContainer>
            <ProductCategoryForm
                formData={formData}
                onSubmit={onSubmit}
                onCancel={onCancel}
                onChange={onChange}
                isSaveLoading={isAddProductCategoryLoading}
                errors={errors}
            />
        </OWContainer>
    );
};
